import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const DeleteModal = ({ id, deleteTerm, toggle, isOpen, handleDelete }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader>Do you want to delete this {deleteTerm}?</ModalHeader>
      <ModalBody>
        <span>Once you delete changes, they cannot be undone.</span>
      </ModalBody>

      <ModalFooter>
        <Button
          color="danger"
          onClick={() => {
            handleDelete(id);
            toggle();
          }}
        >
          Delete
        </Button>
        <Button className="ms-2" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;
